/** RCON-Konsole: freier Befehl an den aktiven Server, Mono-Scrollback. */

import { useSignal } from "@preact/signals";
import { api, activeServer } from "../store";
import { PageHead, Panel, NoServer } from "../components";
import { PanelGrid, type PanelItem } from "../grid/PanelGrid";
import type { ApiResponse } from "../api";
import { t } from "../i18n";

interface Line { cmd: string; out: string; err: boolean }

export function Console() {
  const cmd = useSignal("");
  const lines = useSignal<Line[]>([]);
  const busy = useSignal(false);
  const edit = useSignal(false);

  async function send(e?: Event) {
    e?.preventDefault();
    const sv = activeServer.value;
    const c = cmd.value.trim();
    if (!sv || c === "" || busy.value) return;
    busy.value = true;
    cmd.value = "";
    try {
      const r = await api.call<ApiResponse & { raw: string }>("rcon", { server: sv, cmd: c });
      lines.value = [...lines.value, { cmd: c, out: r.ok ? (r.raw || t("console.noOutput")) : String(r.error ?? t("common.error")), err: !r.ok }];
    } finally {
      busy.value = false;
    }
  }

  if (!activeServer.value) return (<><PageHead title={t("nav.console")} /><NoServer /></>);

  const items: PanelItem[] = [{
    id: "console", title: t("nav.console"), defaultSpan: 12,
    render: () => (
      <Panel>
        <div class="mono" style="white-space:pre-wrap;min-height:320px;max-height:56vh;overflow:auto;font-size:13px;line-height:1.6">
          {lines.value.length === 0 && <div class="faint">{t("console.ready")}</div>}
          {lines.value.map((l, i) => (
            <div key={i} style="margin-bottom:10px">
              <div style="color:var(--accent-2)">› {l.cmd}</div>
              <div class={l.err ? "down" : "muted"}>{l.out}</div>
            </div>
          ))}
        </div>
        <form class="row" style="margin-top:var(--s4)" onSubmit={send}>
          <span class="mono faint">exec</span>
          <input
            class="input mono grow"
            placeholder="admin.listPlayers"
            value={cmd.value}
            onInput={(e) => (cmd.value = (e.target as HTMLInputElement).value)}
          />
          <button class="btn primary" type="submit" disabled={busy.value}>{t("common.send")}</button>
        </form>
      </Panel>
    ),
  }];

  return (
    <div class="view-enter">
      <PageHead title={t("nav.console")} sub={t("console.sub")}>
        <button class={`btn sm ${edit.value ? "primary" : ""}`} onClick={() => (edit.value = !edit.value)}>{edit.value ? t("dashboard.editDone") : t("dashboard.edit")}</button>
        <button class="btn sm ghost" onClick={() => (lines.value = [])}>{t("common.clear")}</button>
      </PageHead>
      <PanelGrid view="console" items={items} edit={edit} />
    </div>
  );
}
